/* =====================================================================
   RYNOR – no cart page: every road to "the cart" opens the cart drawer

   1) Remembers the page the shopper is on, so /cart can send them straight back to it
      (sections/rynor-cart-redirect.liquid, used by templates/cart.json).
   2) Opens the drawer when a page loads with #open-cart – that's how /cart sends them back.
   3) Any link to /cart (the "View cart" links on product cards, menus, emails opened in the
      same tab…) opens the drawer instead of leaving the page. The bag icon is the theme's own
      opener and already does this; if it was tapped before the theme's scripts were ready,
      the link goes to /cart, which comes straight back here with the drawer open.

   Opening works exactly like tapping the bag icon (assets/cart.js › .js-mini-cart-trigger):
   fetch the cart, re-draw the drawer (that also clears its loading overlay), then slide it in.
   Theme settings › Cart › Cart type must stay "Drawer" – there is no cart page to fall back on.

   Loaded on every page by snippets/cart-mini.liquid (the drawer itself).
   ===================================================================== */
(function () {
  'use strict';

  if (window.RynorCartLink) return;

  var KEY = 'rynor:last-page';
  var HASH = '#open-cart';
  var CART_PATH = /^\/(?:[a-z]{2}(?:-[a-zA-Z]{2,4})?\/)?cart\/?$/;

  /* 1) the page to come back to */
  try {
    if (!CART_PATH.test(window.location.pathname)) {
      window.sessionStorage.setItem(KEY, window.location.pathname + window.location.search);
    }
  } catch (e) {}

  function cartConfig() {
    var el = document.getElementById('cart-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  function themeReady() {
    var W = window.WAU;
    return !!(W && W.ThemeCart && typeof W.ThemeCart.getCart === 'function' &&
      W.AjaxCart && typeof W.AjaxCart.updateView === 'function' &&
      typeof W.AjaxCart.showDrawer === 'function' &&
      document.querySelector('[data-wau-slideout="ajax-cart"]'));
  }

  /* the bag icon's own steps: fresh cart → re-draw the drawer → open it */
  function open() {
    var config = cartConfig();
    if (!config || !themeReady()) return false;
    var W = window.WAU;
    if (W.CartUpsell && typeof W.CartUpsell.prime === 'function') {
      try { W.CartUpsell.prime(config, { immediate: true }); } catch (e) {}
    }
    W.ThemeCart.getCart().then(function (cart) {
      W.AjaxCart.updateView(config, cart);
      if (config.cart_action === 'modal_cart' && typeof W.AjaxCart.showModal === 'function') W.AjaxCart.showModal(config);
      else W.AjaxCart.showDrawer(config);
    }).catch(function (err) {
      if (window.console) console.warn('[rynor-cart-link]', err && err.message);
    });
    return true;
  }

  /* 2) arrived from /cart */
  function openFromHash() {
    if (window.location.hash !== HASH) return;
    try {
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
    } catch (e) {}
    var tries = 0;
    (function attempt() {
      if (open()) return;
      if (++tries < 60) window.setTimeout(attempt, 100); /* the theme's scripts can take a moment on phones */
    })();
  }

  /* 3) links to /cart */
  function isCartLink(a) {
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return false;
    var url;
    try { url = new URL(href, window.location.href); } catch (e) { return false; }
    if (url.origin !== window.location.origin) return false;
    if (/(^|&)view=/.test(url.search.replace(/^\?/, ''))) return false;
    return CART_PATH.test(url.pathname);
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || !isCartLink(a)) return;
    /* the bag icon is the theme's own opener; left to it so the drawer never opens twice */
    if (a.matches('.js-slideout-open, .js-mini-cart-trigger, [data-wau-slideout-target], [data-wau-modal-target]')) return;
    if (!open()) return; /* theme not ready yet: /cart sends them back here with the drawer open */
    e.preventDefault();
  });

  /* after the theme's own start-up (WAU.AjaxCart.init runs on DOMContentLoaded) */
  var started = false;
  function start() {
    if (started) return;
    started = true;
    window.setTimeout(openFromHash, 0);
  }
  if (document.readyState === 'complete') start();
  else {
    document.addEventListener('DOMContentLoaded', start);
    window.addEventListener('load', start);
  }

  window.RynorCartLink = { open: open };
})();
